import { z } from 'zod/v4'
import createComponentSchema from '../util/createComponentSchema'

const WelcomeModalSchema = createComponentSchema(
  'WelcomeModal',
  z.object({
    title: z.string(),
    image: z.object({
      url: z.string(),
      alt: z.string().optional()
    }),
    content: z.string(),
    main_button: z.object({
      label: z.string(),
      url: z.string(),
      target: z.union([z.literal('_self'), z.literal('_blank')]).optional()
    }),
    dismiss_button: z.object({
      label: z.string()
    })
  })
)

export default WelcomeModalSchema
